export default __webpack_public_path__ + "static/media/print-icon.b71bd023.svg";